import { createSlice } from "@reduxjs/toolkit"
import { ApiStatus } from "../../types/api/status"
import { RootState } from "../store"
import { DepartmentContact, DepartmentContactInit } from "../../types/slices/departmentContactType"

const initialState: DepartmentContactInit =
{
    status: ApiStatus.FETCHED,
    departmentContacts: [],
    totalRows: 0,
    errorMessage: undefined,
    selectedDepartmentContact: undefined,
}

const departmentContactSlice = createSlice({
    name: 'departmentContactSlice',
    initialState,
    reducers: {
        onFetchDepartmentContacts(state, { payload }: { payload: DepartmentContact[] }) {
            state.status = ApiStatus.FETCHED
            state.departmentContacts = payload
            state.errorMessage = undefined
        },
        onSetTotalRows(state, { payload }: { payload: number }) {
            state.totalRows = payload
        },
        changeStatus(state, { payload }: { payload: ApiStatus }) {
            state.status = payload
        },
        onSetSelectedDepartmentContact(state, { payload }: { payload: DepartmentContact | undefined }) {
            state.selectedDepartmentContact = payload
        },
    }
})

export const departmentContactState = (state: RootState) => state.departmentContactSlice
export default departmentContactSlice.reducer

export const {
    onFetchDepartmentContacts,
    changeStatus,
    onSetSelectedDepartmentContact,
    onSetTotalRows
} = departmentContactSlice.actions